module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAAXNSR0IArs4c6QAAAUlJREFUOE+tlL9Lw0AUx7/vdGkNOgkOJdDBTQcnwcHVycGlIOikYEujQ1PBseBUk9ZFUumgo0Kho4KgQtC/xopILgqS5OQyNaKxp3nTwb334X3fL0KKTbSNeRaFzfEgXH856L6m+VLap2ZXHgEsAXjgPFxBo/v2k38qKNfcLbCxwCWgCIhbznKrqB2/fwdLBcmAKcsohhS4ABVI0JXnP62h0fv4CvsVJAMmj3ZmI8ZcADMA+lwflFDqhcOwkUAyQLPKcwDdgTANiAuuP28Ow0YGSVi+VV5ggu6lYgE6801nGwQh/5RAsUyruhhRdCOfIDrhNWdPwpRBsUy7ugyKriGQJ1DLqzt10uxKnNq/TNBhdqC/ZJKQJtD29jumco0SxYZwuHlqKBc72X6c+2ZnS7n9yYHEJdcHG8oDmcmKZLK0mZ2RzA6byqn9BD0CnhvPiVFaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/media/next.png
// module id = kZx+
// module chunks = 1